// Print/save-as-PDF for a single assistant message. The extracted
// <!--title:--> names the file (browsers use document.title for the PDF
// filename); @media print CSS (see AiPrintStyles in AiMessage.tsx) hides
// everything except the marked message.

export const titleSlug = (title: string | null | undefined): string =>
  (title || 'answer')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60) || 'answer';

export const printFileName = (title: string | null | undefined, now: Date = new Date()): string => {
  const stamp = now.toISOString().slice(0, 16).replace(/[:T]/g, '-');
  return `stackiq-${titleSlug(title)}-${stamp}`;
};

export const PRINT_BODY_CLASS = 'stackiq-printing';
export const PRINT_TARGET_CLASS = 'stackiq-print-target';

export const printMessage = (element: HTMLElement, title: string | null) => {
  const previousTitle = document.title;
  document.title = printFileName(title);
  element.classList.add(PRINT_TARGET_CLASS);
  document.body.classList.add(PRINT_BODY_CLASS);

  const cleanup = () => {
    document.title = previousTitle;
    element.classList.remove(PRINT_TARGET_CLASS);
    document.body.classList.remove(PRINT_BODY_CLASS);
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup);

  window.print();
  // Most browsers block on print(); afterprint handles the rest. The timeout
  // is a safety net for browsers that return immediately.
  setTimeout(cleanup, 2000);
};
